<template>

    <b-container class="h-100 dictionary-page">
      <v-card class="card-container">
        <v-card-title>
          <v-row>
            <v-col cols="auto">
              <v-btn
                      dense
                      color="var(--color-blue)"
                      @click="showAddModal"
                      dark
              >
                <span class="btn-text"><v-icon dark>add</v-icon> Добавить город</span>
              </v-btn>
            </v-col>
            <v-col>
              <v-text-field
                      class="search-block"
                      v-model="search"
                      prepend-inner-icon="mdi-magnify"
                      single-line
                      solo
                      placeholder="Поиск"
                      dense
                      hide-details
              />
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="h-100 p-0" style="overflow-y: scroll">
          <v-list flat>
            <v-list-item-group>
              <v-list-item v-for="item in filteredItems"  :key="item.id"  :value="item" >
                <v-list-item-content>
                  <v-list-item-title v-text="item.cityName"></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn @click="showEditModal(item)" class="item-action" icon><v-icon>mdi-pencil</v-icon></v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
      </v-card>

      <b-modal
        id="modalAdd"
        centered
        size="lg"
        title="Добавление новой записи"
      >
        <b-container fluid>
          <b-row class="mb-2">
            <b-col>
              <label class="custom-input-label">Город</label>
              <b-input
                v-model="cityEditModel.cityName"
                required
              />
            </b-col>
          </b-row>
          <b-row class="mb-2 px-3">
            <label class="custom-input-label">Местоположение</label>
            <googleMap
              :name="'city'"
              :lat-c="cityEditModel.latitude"
              :lng-c="cityEditModel.longitude"
              :h="'50vh'"
              :w="'80vh'"
              @markerChanged="setLocation"
            />
          </b-row>
        </b-container>
        <template slot="modal-footer">
          <div class="w-100">
            <v-row no-gutters  justify="space-between">

              <v-spacer></v-spacer>
              <v-col cols="auto" class="mr-2">
                <v-btn
                        color="var(--color-blue)"
                        dark
                        size="sm"
                        @click="onSave"
                >
                  Сохранить
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                        class="cancel-btn"
                        outlined
                        color="var(--color-3)"
                        size="sm"
                        @click="$bvModal.hide('modalAdd')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </div>
        </template>
      </b-modal>

      <b-modal
        id="modalEdit"
        centered
        size="lg"
        title="Редактирование записи"
      >
        <b-container fluid>
          <b-row class="mb-2">
            <b-col>
              <label class="custom-input-label">Город</label>
              <b-input
                v-model="cityEditModel.cityName"
                required
              />
            </b-col>
          </b-row>
          <b-row class="mb-2 px-3">
            <label class="custom-input-label">Местоположение</label>
            <googleMap
              :name="'city'"
              :lat-c="cityEditModel.latitude"
              :lng-c="cityEditModel.longitude"
              :h="'50vh'"
              :w="'80vh'"
              @markerChanged="setLocation"
            />
          </b-row>
        </b-container>
        <template slot="modal-footer">
          <div class="w-100">
            <v-row no-gutters  justify="space-between">
              <v-col cols="auto">
                <v-btn
                        outlined
                        color="var(--color-red)"
                        size="sm"
                        @click="deleteItem"
                >
                  <v-icon>mdi-delete</v-icon> Удалить
                </v-btn>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="auto" class="mr-2">
                <v-btn
                        color="var(--color-blue)"
                        dark
                        size="sm"
                        @click="onSave"
                >
                  Сохранить
                </v-btn>
              </v-col>
              <v-col cols="auto">
                <v-btn
                        class="cancel-btn"
                        outlined
                        color="var(--color-3)"
                        size="sm"
                        @click="$bvModal.hide('modalEdit')"
                >
                  Отмена
                </v-btn>
              </v-col>
            </v-row>
          </div>

        </template>
      </b-modal>
    </b-container>

</template>

<script>
  import mapper from 'automapper'
  import googleMap from '../../components/googleMap.vue'
    export default {
        name: "Cities",
      components: {googleMap},
      data() {
        return {
          selected:null,
          search:'',
          Fields:[{
            key:"cityName",
            label:"Название"
          }],
          cityEditModel:{
            id:null,
            cityName:null,
            latitude:null,
            longitude:null
          }
        }
      },
      computed:{
        filteredItems(){
          var items = this.$store.state.Cities.items;
          if(items!=null) {
            return items.filter((elem) => {
              return new RegExp(this.search, 'ig').test(elem.cityName);
            });
          }
          else return [];
        }
      },
      created(){
        this.$store.dispatch("Cities/loadCities").catch((err) => {
          console.log(err)
          this.$bvToast.toast(err.message, {
            title: `Ошибка загрузки списка городов!`,
            variant: "danger",
            toaster: 'b-toaster-bottom-right',
            autoHideDelay: 3000,
            solid: true
          })
        });
        mapper.createMap("CityModel", "EditCityModel")
      },
      methods:{
        setLocation(location){
          if(location!=null){
            this.cityEditModel.latitude=location.lat;
            this.cityEditModel.longitude=location.lng;
          }
        },

        showAddModal(){
          this.resetMark();
          this.$bvModal.show('modalAdd')
        },
        showEditModal(item){
            this.selected=item
          mapper.map("CityModel", "EditCityModel", this.selected, this.cityEditModel)
          this.$bvModal.show('modalEdit')
        },

        resetMark(){
          for (var key in this.cityEditModel){
            this.cityEditModel[key]=null;
          }
        },

        onSave(){
          //если есть id, то редактируем запись, иначе добавляем
          if(this.cityEditModel.id!=null){
            try {
              this.$store.dispatch('Cities/editCity', this.cityEditModel).then(()=> {
                  this.$bvToast.toast("Город успешно обновлен", {
                    variant: "success",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                  })
                }
              ).catch(err=>{
                this.$bvToast.toast(err.message, {
                  title: `Ошибка обновления города!`,
                  variant: "danger",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
              });
            }catch(e){
              console.log(e)
            }
            this.$bvModal.hide('modalEdit')
          }
          else{
            try {
              this.$store.dispatch('Cities/addCity', this.cityEditModel).then(()=>{
                this.$bvToast.toast("Город успешно добавлен",{
                  variant: "success",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
              }).catch(err=>{
                this.$bvToast.toast(err.message, {
                  title: `Ошибка добавления города!`,
                  variant: "danger",
                  toaster: 'b-toaster-bottom-right',
                  autoHideDelay: 3000,
                  solid: true
                })
              });
            }catch(e){
              console.log(e)
            }
            this.$bvModal.hide('modalAdd')
          }
        },

        deleteItem(){
          this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
            title: 'Подтверждение',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Удалить',
            cancelTitle: 'Отмена',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          })
            .then(value => {
              if(value==true) {
                this.$store.dispatch("Cities/deleteCity", this.selected.id).then(() => {
                  this.$bvToast.toast("Город успешно удален", {
                    variant: "success",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                  })
                }).catch(err => {
                  this.$bvToast.toast(err.message, {
                    title: `Ошибка удаления города!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                  })
                });
                this.selected = null;
              }
            })
            .catch(err => {
              // An error occurred
            })
        },

        itemSelect(item){
          this.selected=item;
        }
      }
    }
</script>

<style scoped>

</style>
